import { useContext } from 'react';

import { AuthProviderContext } from './AuthProvider';

const useAuthContext = () => {
  const context = useContext(AuthProviderContext);
  if (!context) {
    throw new Error('useAuthContext must be used within a AuthProvider');
  }

  return context;
};

export default useAuthContext;
